import { createReducer } from '@reduxjs/toolkit';
import omit from 'lodash/omit';
import pick from 'lodash/pick';

import {
  ActionFailureType,
  ActionSuccessType,
  GET_EXPERT_PROFILE,
  GET_EXPERT_VISIBILE_PACKAGES,
  GET_EXPERT_VISIBILE_SESSIONS,
  GET_IN_PERSON_MEETING_LOCATIONS_FOR_SCHEDULING,
  GET_SCHEDULING_DATA,
} from 'constants/redux-actions';

const initState = {};

const expertProfileReducer = createReducer(initState, {
  [ActionSuccessType(GET_EXPERT_PROFILE)]: (prevState, action) => ({
    ...pick(prevState, ['sessions', 'packages', 'schedulingData']),
    ...action.payload.data,
  }),
  [ActionSuccessType(GET_SCHEDULING_DATA)]: (prevState, action) => ({
    ...prevState,
    schedulingData: action.payload.data,
  }),
  [ActionFailureType(GET_SCHEDULING_DATA)]: (prevState) => omit(prevState, ['schedulingData']),
  [ActionSuccessType(GET_IN_PERSON_MEETING_LOCATIONS_FOR_SCHEDULING)]: (prevState, action) => ({
    ...prevState,
    inPersonMeetingLocationsForScheduling: action.payload.data,
  }),
  [ActionSuccessType(GET_EXPERT_VISIBILE_SESSIONS)]: (prevState, action) => ({
    ...prevState,
    sessions: action.payload.data,
  }),
  [ActionSuccessType(GET_EXPERT_VISIBILE_PACKAGES)]: (prevState, action) => ({
    ...prevState,
    packages: action.payload.data,
  }),
});

export default expertProfileReducer;
